// extracted by mini-css-extract-plugin
export default {"dlArrayItemRemoveButton":"src-js-containers-auto_layout-components-wrappers-ArrayScreenWrapperRemoveButton---dlArrayItemRemoveButton---F-GNV"};